import { render } from "./MRedeemableTokens.vue?vue&type=template&id=676c59d0&scoped=true&ts=true"
import script from "./MRedeemableTokens.vue?vue&type=script&lang=ts"
export * from "./MRedeemableTokens.vue?vue&type=script&lang=ts"

import "./MRedeemableTokens.vue?vue&type=style&index=0&id=676c59d0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676c59d0"]])

export default __exports__